// Fetches the active system's `condition` Family into the store (issue 36).
//
// Split out of `config/conditions.js` so that the store stays a leaf module
// with no imports. `utils/formatTracker.js` — a pure function with pure tests —
// reads `conditionName` from the store; when the store itself imported apiClient,
// two test suites stopped running entirely because Jest cannot parse axios's
// ESM build. Anything that needs the network imports THIS module instead.

import apiClient from './axios';
import { getConditions, installConditions } from './conditions';

let loadedFor = null;
let inFlight = null;

/**
 * Resolve the conditions for `system`. Safe to call repeatedly — it resolves
 * once per system, and a system with no `condition` Family (404) keeps the
 * shipped fallback rather than emptying the tracker.
 */
export function loadConditions(system) {
  if (loadedFor === system) return Promise.resolve(getConditions());
  if (inFlight) return inFlight;

  inFlight = apiClient
    .get('/api/conditions', { params: { tracker_selectable: true, limit: 200 } })
    .then((res) => {
      const rows = (res && res.data && res.data.conditions) || [];
      installConditions(rows.map((r) => ({
        slug: r.slug,
        name: r.name,
        description: r.description || '',
      })));
      loadedFor = system;
      return getConditions();
    })
    .catch(() => {
      // No `condition` Family for this system, or the request failed. The
      // fallback stands; the tracker is never left without conditions.
      loadedFor = system;
      return getConditions();
    })
    .finally(() => { inFlight = null; });

  return inFlight;
}

/** Test seam. */
export function resetConditionsLoader() {
  loadedFor = null;
  inFlight = null;
}
